export const ADD_COUPON_RATE = 'ADD_COUPON_RATE';
export const REMOVE_COUPON_RATE = 'REMOVE_COUPON_RATE';
export const REMOVE_COUPON_RATES = 'REMOVE_COUPON_RATES';

export const SET_COUPON_BET_TYPE = 'SET_COUPON_BET_TYPE';
export const SET_COUPON_AMOUNT = 'SET_COUPON_AMOUNT';

export const ACCEPT_RATE_VALUE_CHANGE = 'ACCEPT_RATE_VALUE_CHANGE';

export const CHANGE_COUPON_SLIP_AMOUNT = 'CHANGE_COUPON_SLIP_AMOUNT';



// WEBPACK FOOTER //
// ./js/actions/CouponRate.js